import {useQuery} from '@apollo/client';
import {InputNumber} from 'antd';

import {indicators, indicatorsVariables} from '../../../shared/graphql/__generated__/indicators';
import {QUERY_INDICATORS} from '../../../shared/graphql/indicator';

export const InputWithValue = (props: any) => {

    const indicators = useQuery<indicators,indicatorsVariables>(QUERY_INDICATORS, {
        variables: {
            filters: {
                identifier: {eq: props.indicator},
            },
            sort: ['createdAt:DESC'],
            pagination: {
                limit: 1
            }
        }
    })

    const value = indicators.data?.indicators ? indicators.data.indicators[0]?.value : undefined

    // eslint-disable-next-line
    return <InputNumber {...props} placeholder={value}/>

}